/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import * as go from 'gojs';

import type { GoMake } from './shared';
import { createTurnNodeTemplate } from './turn-node';
import { createEndNodeTemplate } from './end-node';
import { createStartNodeTemplate } from './start-node';
import { createAgentNodeTemplate } from './agent-node';
import { createToolNodeTemplate } from './tool-node';
import { createSkeletonNodeTemplate } from './skeleton-node';
import { createTurnLoaderNodeTemplate } from './turn-loader-node';
import { createLinkTemplate } from './link';

// Re-export all template creators
export type { GoMake } from './shared';
export { createNodeToolTip } from './shared';
export {
  createTurnNodeTemplate,
  startTurnPaginationAnimation,
  stopTurnPaginationAnimation,
} from './turn-node';
export { createEndNodeTemplate } from './end-node';
export { createStartNodeTemplate } from './start-node';
export { createAgentNodeTemplate } from './agent-node';
export { createToolNodeTemplate } from './tool-node';
export { createSkeletonNodeTemplate } from './skeleton-node';
export { startSkeletonAnimation, stopSkeletonAnimation } from './skeleton-node';
export { createTurnLoaderNodeTemplate } from './turn-loader-node';
export { createLinkTemplate } from './link';

/**
 * Helper to register all templates (turn, end, agent, tool, skeleton)
 */
export function registerAllTemplates(diagram: go.Diagram, $: GoMake): void {
  diagram.nodeTemplateMap.add('start', createStartNodeTemplate($));
  diagram.nodeTemplateMap.add('turn', createTurnNodeTemplate($));
  diagram.nodeTemplateMap.add('end', createEndNodeTemplate($));
  diagram.nodeTemplateMap.add('agent', createAgentNodeTemplate($));
  diagram.nodeTemplateMap.add('tool', createToolNodeTemplate($));
  diagram.nodeTemplateMap.add('skeleton', createSkeletonNodeTemplate($));
  diagram.nodeTemplateMap.add('turn_loader', createTurnLoaderNodeTemplate($));
  diagram.linkTemplate = createLinkTemplate($);
}
